module.exports = __webpack_public_path__ + "img/a_2.a3e7f2c0.png";